import { indexBy, prop } from 'remeda';

const indexById: { <T extends {id: number}>(arg: T[]): Record<number, T> } = indexBy(prop('id'));

export default indexById;
